import { tv } from 'tailwind-variants';

export const buttonVariants = tv({
  base: [
    'relative',
    'z-0',
    'inline-flex',
    'items-center',
    'justify-center',
    'gap-2',
    'overflow-hidden',
    'font-semibold',
    'uppercase',
    'tracking-[1px]',
    'truncate',
    'transition-all',
    'duration-300',
    'after:absolute',
    'after:left-2/4',
    'after:top-2/4',
    'after:z-[-1]',
    'after:h-96',
    'after:w-0',
    'after:-translate-x-2/4',
    'after:-translate-y-2/4',
    'after:rotate-45',
    'after:transform-gpu',
    'after:opacity-0',
    'after:transition-all',
    'after:duration-300',
    'after:content-[""]',
    'hover:after:w-[135%]',
    'hover:after:opacity-100',
    'focus:after:w-[135%]',
    'focus:after:opacity-100',
    'active:after:w-[135%]',
    'active:after:opacity-100'
  ],
  variants: {
    variant: {
      primary: [
        'bg-blue-400',
        'text-white',
        'after:bg-blue-300',
        'focus:text-white',
        'focus:after:bg-blue-300',
        'active:text-white',
        'active:after:bg-blue-200',
        'disabled:bg-grey-200',
        'disabled:text-grey-400',
        'disabled:after:bg-grey-200'
      ],
      secondary: [
        'bg-sienna-400',
        'text-white',
        'after:bg-sienna-300',
        'focus:bg-sienna-300',
        'focus:text-white',
        'active:bg-sienna-200',
        'active:text-white',
        'disabled:bg-grey-200',
        'disabled:text-grey-400',
        'disabled:after:bg-grey-200'
      ],
      light: [
        'bg-white',
        'text-grey-800',
        'after:bg-grey-200',
        'focus:bg-grey-300',
        'focus:text-grey-800',
        'active:bg-grey-400',
        'active:text-grey-800',
        'disabled:bg-grey-200',
        'disabled:text-grey-400',
        'disabled:after:bg-grey-200'
      ]
    },
    outline: {
      true: [
        'bg-transparent',
        'disabled:bg-grey-200',
        'disabled:shadow-[inset_0_0_0_1px_rgba(240,240,240,1)]',
        'disabled:after:bg-grey-200'
      ],
      false: []
    },
    size: {
      xs: ['px-4', 'py-2', 'text-xs'],
      sm: ['px-4', 'py-3', 'text-xs'],
      md: ['px-6', 'py-4', 'text-sm', 'leading-4'],
      lg: ['px-8', 'py-6', 'text-sm', 'leading-4']
    }
  },

  compoundVariants: [
    {
      variant: 'primary',
      outline: true,
      class: [
        'text-blue-400',
        'shadow-[inset_0_0_0_1px_rgba(0,0,143,1)]',
        'hover:text-white',
        'disabled:text-grey-400'
      ]
    },
    {
      variant: 'secondary',
      outline: true,
      class: [
        'text-sienna-400',
        'shadow-[inset_0_0_0_1px_rgba(210,71,35,1)]',
        'hover:text-white',
        'disabled:text-grey-400'
      ]
    },
    {
      variant: 'light',
      outline: true,
      class: [
        'text-white',
        'shadow-[inset_0_0_0_1px_rgba(255,255,255,1)]',
        'after:bg-white',
        'hover:text-grey-800',
        'disabled:text-grey-200'
      ]
    }
  ],

  defaultVariants: {
    variant: 'primary',
    outline: false,
    size: 'md'
  }
});

export const plainButtonVariants = tv({
  base: [
    'w-fit',
    'inline-flex',
    'items-center',
    'justify-center',
    'gap-2',
    'font-semibold',
    'uppercase',
    'tracking-[1px]'
  ],

  variants: {
    variant: {
      primary: [
        'text-blue-400',
        'hover:text-blue-300',
        'focus:shadow-[inset_0_0_0_2px_rgba(0,0,143,0.5)]',
        'active:text-blue-200',
        'disabled:text-grey-400'
      ],
      secondary: [
        'text-sienna-400',
        'hover:text-sienna-300',
        'focus:shadow-[inset_0_0_0_2px_rgba(210,71,35,0.5)]',
        'active:text-sienna-200',
        'disabled:text-grey-400'
      ],
      light: [
        'text-white',
        'hover:text-grey-300',
        'focus:bg-grey-800',
        'focus:text-grey-300',
        'focus:shadow-[inset_0_0_0_2px_rgba(255,255,255,0.5)]',
        'active:text-grey-400',
        'disabled:text-grey-400'
      ]
    },
    size: {
      sm: 'text-xs',
      lg: ['text-sm', 'leading-4']
    }
  },

  defaultVariants: {
    variant: 'primary',
    size: 'lg'
  }
});
